
export const getLanguageList = (t: (t: string) => string) =>
  LanguageList.map(language => ({ ...language, text: t(language.text) }));

export const LanguageList = [
  {
    code: 'en',
    text: 'english'
  },
  {
    code: 'de',
    text: 'german'
  }
];

export const LanguageConfig = {
  lng: localStorage.getItem('i18nextLng') || 'en',
  fallbackLng: 'en',
  preload: LanguageList.map(l => l.code),
  ns: ['translation'],
  defaultNS: 'translation',
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json'
  },
  react: {
    useSuspense: false,
    wait: false
  }
};

export const updateMomentLanguage = (code: string) => {
  console.log(code);
  // TODO add day.js
  // moment.updateLocale(code, LanguageList.find(lang => lang.code === code)?.moment_locale);
};
